// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".y2xPwwAUPYPHGOOCwIro {\n  color: #722ed1;\n}\n", "",{"version":3,"sources":["webpack://./../../common/components/message/highlightedMessage.module.less"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".token {\n  color: #722ed1;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"token": "y2xPwwAUPYPHGOOCwIro"
};
export default ___CSS_LOADER_EXPORT___;
